import { LOGIN, PENDING, FULFILLED, REJECTED ,GET_CSRF } from "../../utility/constants";
import { v4 as uuidv4 } from 'uuid';

/**
 * Login async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function login(data){
	return {
		types: [`${LOGIN}_${PENDING}`, `${LOGIN}_${FULFILLED}`, `${LOGIN}_${REJECTED}`],
		method: 'POST',
		url: 'login',
		data: data,
		payload: {}
	}
}

export function getcsrf() {
	const uniqueId = uuidv4();
	return{
        types: [`${GET_CSRF}_${PENDING}`, `${GET_CSRF}_${FULFILLED}`, `${GET_CSRF}_${REJECTED}`],
        method: 'POST',
        url: 'login/csrfToken',
		data: uniqueId,
		payload: {}
    }

}